import React, {
    useMemo,
    useState,
    useCallback,
    useRef,
    useEffect
} from "react";
import { AgGridReact } from "ag-grid-react";
import './Modal.css';
import {
    Button,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Dialog,
    DialogTitle,
    DialogActions,
} from "@mui/material";
import "./SettingConfig.css"
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "../../components/common/datatable/DataTable.css";
import TopSection from "../LT/TopSection";
import { MultiDropdown } from "../../components/common/MultiDropdown";
import ButtonComponent from "../../components/common/button/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import { getBuyerDropdownFilter } from "../../redux/actions/BuyerDropdownFilterSlice";
import { deleteRestrictionRuleEndpoint, getAllRestrictionRuleEndpoint, getBuyerDropdownFilterEndpoint, postRestrictRuleEndpoint, putRestrictionRuleEndpoint, searchRestrictionRuleEndpoint } from "../../common/endpoints";
import AddRestrictRuleMoodal from "./AddRestrictRuleModal";
import { postRestrictRuleSlice } from "../../redux/actions/postRestrictRuleSlice";
import { getAllRestrictionRuleSlice } from "../../redux/actions/getAllRestrictionRuleSlice";
import { deleteRestrictionRuleSlice } from "../../redux/actions/deleteRestrictionRuleSlice";
import { Loader } from "../../components/common/Loader";
import { putRestrictionRuleSlice } from "../../redux/actions/putRestrictionRuleSlice";
import { searchRestrictionRuleSlice } from "../../redux/actions/searchRestrictionRuleSlice";

const ForecastPublishExclusion = () => {
    const dispatch = useDispatch();
    const [allData, setAllData] = useState([]);
    const [plantOptions, setPlantOptions] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [showDelete, setShowDelete] = useState(false);
    const [deleteRow, setDeleteRow] = useState(null);
    const [parentVendorOptions, setParentVendorOptions] = useState([]);
    const [childVendorOptions, setChildVendorOptions] = useState([]);
    const [materialOptions, setMaterialOptions] = useState([]);
    const [scodeOptions, setScodeOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const loggedInUserEmail = localStorage.getItem("userEmail");
    const gridRef = useRef(null);
    const [openAddModal, setOpenAddModal] = useState(false);
    const [editRow, setEditRow] = useState(null);
    const selector = useSelector((state) => state.getAllRestrictionRuleSlice);
    const searchLoading = useSelector((state) => state.searchRestrictionRuleSlice);
    const pagination = true;
    const paginationPageSize = 10;
    const paginationPageSizeSelector = [10, 50, 100, 500, 1000];
    const roleDetails = localStorage.getItem("userRole");
    const isAppAdmin = roleDetails === "App Admin";

    const [filters, setFilters] = useState({
        plant: [],
        parentVendor: [],
        childVendor: [],
        category: [],
        material: [],
        scode: []
    });

    const isSearchEnabled =
        filters.plant.length > 0 ||
        filters.parentVendor.length > 0 ||
        filters.childVendor.length > 0 ||
        filters.category.length > 0 ||
        filters.material.length > 0 ||
        filters.scode.length > 0;

    // ---------------------------
    // Validation rule
    // ---------------------------
    const isRowValid = (row) => {
        const hasOneEntity =
            !!row.plantCode?.toString().trim() ||
            !!row.parentVendorName?.toString().trim() ||
            !!row.childVendorId?.toString().trim() ||
            !!row.tccMaterialNumber?.toString().trim() ||
            !!row.scode?.toString().trim();

        return hasOneEntity
    };

    const getUniqueValues = (arr) => [...new Set(arr.filter(Boolean))];

    const handleSelectedItemsChange = (name, newSelectedItems) => {
        const optionMap =
            name === "plant" ? plantOptions :
                name === "parentVendor" ? parentVendorOptions :
                    name === "childVendor" ? childVendorOptions :
                        name === "category" ? categoryOptions :
                            name === "material" ? materialOptions :
                                name === "scode" ? scodeOptions :
                                    [];

        const normalized = newSelectedItems
            .map(sel => optionMap.find(opt => opt.value === sel.value))
            .filter(Boolean);

        setFilters((prev) => ({
            ...prev,
            [name]: normalized,
        }));
    };

    const gridOptions = {
        // onFilterChanged,
        overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
        overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
        defaultColDef: {
            autoHeight: true,
            cellStyle: {
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.5,
                display: "flex",
                alignItems: "center",
            },
            valueGetter: (params) => {
                if (!params.data) return "-";

                const field = params.colDef.field;
                const value = params.data[field];

                return value === null || value === undefined || value === "" ? "-" : value;
            },
        }

    }

    const columnDefs = useMemo(
        () => [
            {
                field: "plantDisplay",
                headerName: "Plant Code",
                width: 80,
            },
            {
                field: "parentVendorDisplay",
                headerName: "Parent Vendor Name",
                width: 120,
            },
            {
                field: "childVendorDisplay",
                headerName: "Child Vendor Code",
                width: 150,
            },
            {
                field: "materialCode",
                headerName: "Material",
                width: 80,
            },
            {
                field: "scode",
                headerName: "External Material Group",
                width: 80,
            },
            {
                field: "businessCategory",
                headerName: "Business Category",
                width: 140,
            },
            {
                field: "lastUpdated",
                headerName: "Last Updated Date",
                width: 140,
                valueFormatter: (params) => {
                    return params.value ? params.value.split("T")[0] : "";
                }
            },
            {
                field: "updatedBy",
                headerName: "Last Updated By",
                width: 140,
            },
            ...(!isAppAdmin
                ? []
                : [
                    {
                        headerName: "Actions",
                        width: 160,
                        cellRenderer: (params) => {
                            const row = params.data;

                            return (
                                <div style={{ display: "flex", gap: 6 }}>

                                    {!row.isNew && (
                                        <IconButton
                                            size="small"
                                            disableRipple
                                            sx={{
                                                backgroundColor: "transparent !important",

                                                "&:hover": {
                                                    backgroundColor: "transparent !important",
                                                },

                                                "&:focus": {
                                                    backgroundColor: "transparent !important",
                                                },

                                                "&:active": {
                                                    backgroundColor: "transparent !important",
                                                },

                                                "& .MuiSvgIcon-root": {
                                                    color: "#1976d2 !important",
                                                    opacity: "1 !important",
                                                    visibility: "visible !important",
                                                },

                                                "&:hover .MuiSvgIcon-root": {
                                                    color: "#1976d2 !important",
                                                    opacity: "1 !important",
                                                    visibility: "visible !important",
                                                },
                                            }}
                                            onClick={() => {
                                                const row = params.data;
                                                setEditRow({
                                                    id: row.id,

                                                    plantCode: row.plantCode
                                                        ? [{
                                                            value: row.plantCode,
                                                            label: `${row.plantCode} | ${row.plantName || ""}`
                                                        }]
                                                        : [],

                                                    parentVendorId: row.parentVendorId
                                                        ? [{
                                                            value: row.parentVendorId,
                                                            label: row.parentVendorName
                                                                ? `${row.parentVendorId} | ${row.parentVendorName}`
                                                                : row.parentVendorId
                                                        }]
                                                        : [],
                                                    parentVendorName: row.parentVendorName
                                                        ? [{
                                                            value: row.parentVendorName,
                                                            label: row.parentVendorName
                                                        }]
                                                        : [],


                                                    childVendorId: row.childVendorCode
                                                        ? [{
                                                            value: row.childVendorCode,
                                                            label: row.childVendorName
                                                                ? `${row.childVendorCode} | ${row.childVendorName}`
                                                                : row.childVendorCode
                                                        }]
                                                        : [],

                                                    tccMaterialNumber: row.materialCode
                                                        ? [{
                                                            value: row.materialCode,
                                                            label: row.materialCode
                                                        }]
                                                        : [],

                                                    scode: row.scode
                                                        ? [{
                                                            value: row.scode,
                                                            label: row.scode
                                                        }]
                                                        : [],

                                                    businessCategory: row.businessCategory
                                                        ? [{
                                                            value: row.businessCategory,
                                                            label: row.businessCategory
                                                        }]
                                                        : [],
                                                });

                                                setOpenAddModal(true);
                                            }}
                                        >
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                    )}

                                    {/* SAVE BUTTON ONLY FOR EXISTING EDIT ROW */}
                                    {row.isEditing && !row.isNew && (
                                        <ButtonComponent
                                            type="secondary"
                                            minWidth="100px"
                                            label="Save"
                                            height="36px"
                                            disabled={!isRowValid(row) || !row.isModified}
                                            onClick={() => handleEditSave(row)}
                                        />
                                    )}

                                    {/* DELETE BUTTON ONLY FOR EXISTING ROWS */}
                                    {!row.isNew && (
                                        <IconButton
                                            size="small"
                                            disableRipple
                                            onClick={() => {
                                                setDeleteRow(row);
                                                setShowDelete(true);
                                            }}
                                            sx={{
                                                backgroundColor: "transparent !important",
                                                color: "#d32f2f !important",
                                                "&:hover": {
                                                    backgroundColor: "transparent !important",
                                                    color: "#d32f2f !important",
                                                },
                                                "&:focus": {
                                                    backgroundColor: "transparent !important",
                                                    color: "#d32f2f !important",
                                                },
                                                "&:active": {
                                                    backgroundColor: "transparent !important",
                                                    color: "#d32f2f !important",
                                                },
                                            }}
                                        >
                                            <DeleteIcon
                                                fontSize="small"
                                                sx={{
                                                    color: "#d32f2f !important",
                                                }}
                                            />
                                        </IconButton>
                                    )}
                                </div>
                            );
                        },
                    }
                ]
            )
        ],
        [plantOptions, parentVendorOptions, childVendorOptions, categoryOptions, rowData]
    );

    const onCellValueChanged = (params) => {
        const updatedRow = {
            ...params.data,
            isModified: true,
        };

        setRowData((prev) =>
            prev.map((row) =>
                row.id === updatedRow.id ? updatedRow : row
            )
        );
    };

   
    const getFilteredOptions = (currentField, optionList, valueKey) => {
        const filteredRows = allData.filter(row => {
            return (
                (currentField === "plant" ||
                    !filters.plant.length ||
                    filters.plant.some(f => f.value === row.plant)) &&

                (currentField === "parentVendor" ||
                    !filters.parentVendor.length ||
                    filters.parentVendor.some(f => f.value === row.parentVendor)) &&

                (currentField === "childVendor" ||
                    !filters.childVendor.length ||
                    filters.childVendor.some(f => f.value === row.vendorCode)) &&

                (currentField === "material" ||
                    !filters.material.length ||
                    filters.material.some(f => f.value === row.tccMaterialNumber)) &&

                (currentField === "scode" ||
                    !filters.scode.length ||
                    filters.scode.some(f => f.value === row.scode)) &&

                (currentField === "category" ||
                    !filters.category.length ||
                    filters.category.some(f => f.value === row.businessCategory))
            );
        });

        const allowedValues = new Set(
            filteredRows
                .map(row => row[valueKey])
                .filter(Boolean)
        );

        return optionList.filter(opt =>
            allowedValues.has(opt.value)
        );
    };

    const filteredPlantOptions = useMemo(
        () => getFilteredOptions("plant", plantOptions, "plant"),
        [filters, plantOptions, allData]
    );

    const filteredParentVendorOptions = useMemo(
        () => getFilteredOptions("parentVendor", parentVendorOptions, "parentVendor"),
        [filters, parentVendorOptions, allData]
    );

    const filteredChildVendorOptions = useMemo(
        () => getFilteredOptions("childVendor", childVendorOptions, "vendorCode"),
        [filters, childVendorOptions, allData]
    );

    const filteredMaterialOptions = useMemo(
        () => getFilteredOptions("material", materialOptions, "tccMaterialNumber"),
        [filters, materialOptions, allData]
    );

    const filteredScodeOptions = useMemo(
        () => getFilteredOptions("scode", scodeOptions, "scode"),
        [filters, scodeOptions, allData]
    );

    const filteredCategoryOptions = useMemo(
        () => getFilteredOptions("category", categoryOptions, "businessCategory"),
        [filters, categoryOptions, allData]
    );

    useEffect(() => {
        getDropdownData();
        getExclusionList();
    }, []);

    const getDropdownData = async () => {
        try {
            const response = await dispatch(
                getBuyerDropdownFilter({
                    dynamicEndpoint: `${getBuyerDropdownFilterEndpoint}/${loggedInUserEmail}`,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {

                const list = response?.payload || [];
                setAllData(list)
                // PLANT
                setPlantOptions(
                    Array.from(
                        new Map(
                            list.map(item => [
                                item.plant,
                                {
                                    value: item.plant,
                                    label: `${item.plant} | ${item.plantName}`,
                                    title: `${item.plant} | ${item.plantName}`
                                }
                            ])
                        ).values()
                    )
                );

                // PARENT VENDOR
                setParentVendorOptions(
                    Array.from(
                        new Map(
                            list
                                .filter(i => i.parentVendor)
                                .map(item => [
                                    item.parentVendor,
                                    {
                                        value: item.parentVendor,
                                        name: item.parentVendorName,
                                        label: item.parentVendorName
                                            ? `${item.parentVendor} | ${item.parentVendorName}`
                                            : item.parentVendor,
                                        title: item.parentVendorName
                                            ? `${item.parentVendor} | ${item.parentVendorName}`
                                            : item.parentVendor
                                    }
                                ])
                        ).values()
                    )
                );

                // CHILD VENDOR
                setChildVendorOptions(
                    Array.from(
                        new Map(
                            list
                                .filter(i => i.vendorCode)
                                .map(item => [
                                    item.vendorCode,
                                    {
                                        value: item.vendorCode,
                                        label: item.supplierName
                                            ? `${item.vendorCode} | ${item.supplierName}`
                                            : item.vendorCode,
                                        title: item.supplierName
                                            ? `${item.vendorCode} | ${item.supplierName}`
                                            : item.vendorCode
                                    }
                                ])
                        ).values()
                    )
                );

                //matrial
                setMaterialOptions(
                    Array.from(
                        new Map(
                            list
                                .filter(i => i.tccMaterialNumber)
                                .map(item => [
                                    item.tccMaterialNumber,
                                    {
                                        value: item.tccMaterialNumber,
                                        label: item.tccMaterialNumber,
                                        title: item.tccMaterialNumber
                                    }
                                ])
                        ).values()
                    )
                );

                //Scode
                setScodeOptions(
                    Array.from(
                        new Map(
                            list
                                .filter(i => i.scode)
                                .map(item => [
                                    item.scode,
                                    {
                                        value: item.scode,
                                        label: item.scode,
                                        title: item.scode
                                    }
                                ])
                        ).values()
                    )
                );

                // CATEGORY
                setCategoryOptions(
                    Array.from(
                        new Map(
                            list
                                .filter(i => i.businessCategory)
                                .map(item => [
                                    item.businessCategory,
                                    {
                                        value: item.businessCategory,
                                        label: item.businessCategory,
                                        title: item.businessCategory
                                    }
                                ])
                        ).values()
                    )
                );
            }

        } catch (error) {
            console.error("Dropdown API error:", error);
        }
    };

    const getExclusionList = async () => {
        try {
            const response = await dispatch(
                getAllRestrictionRuleSlice({
                    dynamicEndpoint: `${getAllRestrictionRuleEndpoint}?page=${0}&size=${10000}`,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {

                const list = response?.payload?.content || [];

                const formattedData = list.map((item) => ({
                    id: item.id,
                    plantCode: item.plantCode || "",
                    plantName: item.plantName || "",
                    parentVendorName: item.parentVendorName || "",
                    parentVendorId: item.parentVendorId || "",
                    childVendorCode: item.childVendorCode || "",
                    childVendorName: item.childVendorName || "",
                    plantDisplay: formatCodeName(item.plantCode, item.plantName),

                    parentVendorDisplay: formatCodeName(
                        item.parentVendorId,
                        item.parentVendorName
                    ),

                    childVendorDisplay: formatCodeName(
                        item.childVendorCode,
                        item.childVendorName
                    ),
                    materialCode: item.materialCode || "",
                    scode: item.scode || "",
                    businessCategory: item.businessCategory || "",
                    createdBy: item.createdBy || "",
                    updatedBy: item.lastUpdatedBy || "",
                    lastUpdated: item.lastUpdatedDatetime || "",
                    isNew: false,
                    isEditing: false,
                    isModified: false
                }));

                setRowData(formattedData);
            }

        } catch (error) {
            console.error("Exclusion API error:", error);
        }
    };

    const handleAddRule = async (rows) => {
        const r = rows?.[0]; //  ONLY ONE ROW
        try {
            const payload = {
                plantCode: r?.plantCode || "",
                plantName: r?.plantName || "",
                parentVendorId: r?.parentVendorId || "",
                parentVendorName: r?.parentVendorName || "",
                childVendorCode: r?.childVendorCode || "",
                childVendorName: r?.childVendorName || "",
                materialCode: r?.materialCode || "",
                scode: r?.scode || "",
                businessCategory: r?.businessCategory || "",
                user: loggedInUserEmail
            };

            const response = await dispatch(
                postRestrictRuleSlice({
                    dynamicEndpoint: postRestrictRuleEndpoint,
                    data: payload,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {
                const data = response?.payload;

                toast.success(data?.message || "Exclustion Rule created successfully");
                getExclusionList();

                // optionally update grid instantly
                // const newRow = {
                //     id: data?.id,
                //     ...payload,
                //     updatedBy: loggedInUserEmail,
                //     lastUpdated: new Date().toISOString(),
                // };

                // setRowData((prev) => [newRow, ...prev]);

                setOpenAddModal(false);
                setEditRow(null);
            } else {
                toast.error(
                    response?.payload ||
                    "Failed to create rule"
                );
            }

        } catch (error) {
            console.error("Add Rule Error:", error);
            toast.error("Something went wrong");
        }
    };

    const handleEditSave = async (rows) => {
        const r = rows;
        try {
            const payload = {
                id: r?.id,
                plantCode: r?.plantCode || "",
                plantName: r?.plantName || "",
                parentVendorId: r?.parentVendorId || "",
                parentVendorName: r?.parentVendorName || "",
                childVendorCode: r?.childVendorCode || "",
                childVendorName: r?.childVendorName || "",
                materialCode: r?.materialCode || "",
                scode: r?.scode || "",
                businessCategory: r?.businessCategory || "",
                user: loggedInUserEmail
            };

            const response = await dispatch(
                putRestrictionRuleSlice({
                    dynamicEndpoint: `${putRestrictionRuleEndpoint}/${editRow.id}`,
                    data: payload,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {
                toast.success(
                    response?.payload?.message ||
                    "Rule updated successfully"
                );

                await getExclusionList();

                setOpenAddModal(false);
                setEditRow(null);
            } else {
                toast.error(
                    response?.payload ||
                    "Failed to update rule"
                );
            }
        } catch (error) {
            console.error("Edit Rule Error:", error);
            toast.error("Something went wrong");
        }
    };

    const onAddRule = () => {
        setOpenAddModal(true);
    }

    const handleReset = async () => {
        setFilters({
            plant: [],
            parentVendor: [],
            childVendor: [],
            category: [],
            scode: [],
            material: []
        });

        // reload full list
        getExclusionList();
    };

    const handleSearch = async () => {
        try {
            const payload = {
                plantCodes: filters.plant?.map(i => i.value) || [],
                parentVendorNames: filters.parentVendor?.map(i => i.name) || [],
                childVendorCodes: filters.childVendor?.map(i => i.value) || [],
                materialCodes: filters.material?.map(i => i.value) || [],
                scodes: filters.scode?.map(i => i.value) || [],
                businessCategories: filters.category?.map(i => i.value) || [],
                page: 0,
                size: 20,
                sort: "id,desc"
            };

            const response = await dispatch(
                searchRestrictionRuleSlice({
                    dynamicEndpoint: searchRestrictionRuleEndpoint,
                    data: payload   //  IMPORTANT (POST BODY)
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {

                const list = response?.payload?.content || [];

                const formattedData = list.map((item) => ({
                    id: item.id,
                    plantCode: item.plantCode || "",
                    plantName: item.plantName || "",
                    parentVendorName: item.parentVendorName || "",
                    parentVendorId: item.parentVendorId || "",
                    childVendorCode: item.childVendorCode || "",
                    childVendorName: item.childVendorName || "",
                    plantDisplay: formatCodeName(item.plantCode, item.plantName),
                    parentVendorDisplay: formatCodeName(item.parentVendorId, item.parentVendorName),
                    childVendorDisplay: formatCodeName(item.childVendorCode, item.childVendorName),
                    materialCode: item.materialCode || "",
                    scode: item.scode || "",
                    businessCategory: item.businessCategory || "",
                    createdBy: item.createdBy || "",
                    updatedBy: item.lastUpdatedBy || "",
                    lastUpdated: item.lastUpdatedDatetime || "",
                    isNew: false,
                    isEditing: false,
                    isModified: false
                }));

                setRowData(formattedData);
            }

        } catch (error) {
            console.error("Search API error:", error);
            toast.error("Search failed");
        }
    };

    // ---------------------------
    // Delete flow
    // ---------------------------
    const confirmDelete = async () => {
        try {
            if (!deleteRow?.id) return;

            const response = await dispatch(
                deleteRestrictionRuleSlice({
                    dynamicEndpoint: `${deleteRestrictionRuleEndpoint}/${deleteRow.id}`,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {
                toast.success(
                    response?.payload?.message ||
                    "Restriction configuration deleted successfully",
                    { autoClose: 2000 }
                );

                // remove from UI after success
                setRowData((prev) =>
                    prev.filter((r) => r.id !== deleteRow.id)
                );
            } else {
                toast.error(
                    response?.payload?.errorMessage || "Delete failed",
                    { autoClose: 2000 }
                );
            }
        } catch (error) {
            toast.error("Something went wrong while deleting", {
                autoClose: 2000,
            });
        } finally {
            setShowDelete(false);
            setDeleteRow(null);
        }
    };

    const formatCodeName = (code, name) => {
        if (!code) return "";
        if (!name) return code;   // 👈 no pipe if name missing
        return `${code} | ${name}`;
    };

    return (
        <div>
            {/* <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Forecast Publish Restriction" },
                ]}
                tabTitle="Forecast Publish Restriction"
                moduleTitle="Settings & Config"
            /> */}
            <div
                style={{
                    // padding: "10px 0px 20px 0px",
                    marginBottom: 10,
                }}
            >
                {/* Title Row */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        flexWrap: "wrap",
                        // marginBottom: 6,
                    }}
                >
                    {/* <h2
                        style={{
                            margin: 0,
                            fontSize: 24,
                            fontWeight: 600,
                            color: "#111827",
                        }}
                    >
                        Forecast Publish Exclusion
                    </h2> */}
                </div>

                {/* Subtitle */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        flexWrap: "wrap",
                    }}
                >
                    {/* Subtitle */}
                    <div
                        style={{
                            fontSize: 14,
                            color: "#6b7280",
                            paddingBottom: 10,

                        }}
                    >
                        Maintain list to restict forecast publishing for selected Plant/Supplier/Material/External Material Group Combination.
                    </div>


                </div>
            </div>

            {/* ================= FILTER CARD ================= */}
            <div
                style={{
                    background: "#fff",
                    borderRadius: 12,
                    padding: 20,
                    marginBottom: 20,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    border: "1px solid #e5e7eb",
                }}
            >
                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 20,
                    }}
                >
                    <h2
                        style={{
                            margin: 0,
                            fontSize: 20,
                            fontWeight: 600,
                        }}
                    >
                        Filters
                    </h2>
                </div>

                {/* Filter Controls */}
                {/* ================= FILTER CARD ================= */}
                <div
                    style={{
                        background: "#fff",
                        borderRadius: 12,
                        padding: 20,
                        marginBottom: 20,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        border: "1px solid #e5e7eb",
                    }}
                >
                    {/* Header */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 20,
                        }}
                    >
                        <h2
                            style={{
                                margin: 0,
                                fontSize: 20,
                                fontWeight: 600,
                            }}
                        >
                            {/* Filters */}
                        </h2>

                        <div
                            style={{
                                display: "flex",
                                gap: 10,
                            }}
                        >
                            <ButtonComponent
                                type="secondary"
                                maxWidth="120px"
                                label="Search"
                                height="36px"
                                onClick={handleSearch}
                                disabled={!isSearchEnabled || searchLoading.loading}
                            />

                            <ButtonComponent
                                type="primary"
                                maxWidth="120px"
                                label="Reset"
                                height="36px"
                                onClick={handleReset}
                            />
                        </div>
                    </div>

                    {/* Filters Grid */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(3, minmax(250px, 1fr))",
                            gap: "16px",
                        }}
                    >
                        <div className="filter-item">
                            <span>Plant Code</span>
                            <MultiDropdown
                                id="plant"
                                name="plant"
                                options={filteredPlantOptions}
                                height={36}
                                copyPasteDisabled={false}
                                onChangeItems={handleSelectedItemsChange}
                                selectedItemsData={filters.plant}
                                ListboxComponentProps={false}
                            />
                        </div>

                        <div className="filter-item">
                            <span>Parent Vendor Name</span>
                            <MultiDropdown
                                id="parentVendor"
                                name="parentVendor"
                                options={filteredParentVendorOptions}
                                height={36}
                                copyPasteDisabled={false}
                                onChangeItems={handleSelectedItemsChange}
                                selectedItemsData={filters.parentVendor}
                                ListboxComponentProps={false}
                            />
                        </div>

                        <div className="filter-item">
                            <span>Child Vendor Code</span>
                            <MultiDropdown
                                id="childVendor"
                                name="childVendor"
                                options={filteredChildVendorOptions}
                                height={36}
                                copyPasteDisabled={false}
                                onChangeItems={handleSelectedItemsChange}
                                selectedItemsData={filters.childVendor}
                                ListboxComponentProps={false}
                            />
                        </div>

                        <div className="filter-item">
                            <span>Material</span>
                            <MultiDropdown
                                id="material"
                                name="material"
                                options={filteredMaterialOptions}
                                height={36}
                                copyPasteDisabled={false}
                                onChangeItems={handleSelectedItemsChange}
                                selectedItemsData={filters.material}
                                ListboxComponentProps={false}
                            />
                        </div>

                        <div className="filter-item">
                            <span>External Material Group</span>
                            <MultiDropdown
                                id="scode"
                                name="scode"
                                options={filteredScodeOptions || []}
                                height={36}
                                copyPasteDisabled={false}
                                onChangeItems={handleSelectedItemsChange}
                                selectedItemsData={filters.scode || []}
                                ListboxComponentProps={false}
                            />
                        </div>

                        <div className="filter-item">
                            <span>Business Category</span>
                            <MultiDropdown
                                id="category"
                                name="category"
                                options={filteredCategoryOptions}
                                height={36}
                                copyPasteDisabled={false}
                                onChangeItems={handleSelectedItemsChange}
                                selectedItemsData={filters.category}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* ================= Table ================= */}
            <div
                style={{
                    background: "#fff",
                    borderRadius: 12,
                    padding: 20,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    border: "1px solid #e5e7eb",
                }}
            >
                {/* Header */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 15,
                        flexWrap: "wrap",
                        gap: 10,
                    }}
                >
                    <h2
                        style={{
                            margin: 0,
                            fontSize: 20,
                            fontWeight: 600,
                        }}
                    >
                        Forecast Publish Restriction List
                    </h2>

                    <div
                        style={{
                            display: "flex",
                            gap: 10,
                            whiteSpace: "nowrap",
                        }}
                    >
                        {isAppAdmin && <ButtonComponent
                            type="primary"
                            minWidth="220px"
                            label="+ Add"
                            height="35px"
                            onClick={onAddRule}
                        />}

                    </div>
                </div>

                {/* Grid */}
                <div
                    className="ag-theme-quartz"
                    style={{
                        height: 500,
                        width: "100%",
                        borderRadius: 10,
                        overflow: "hidden",
                    }}
                >
                    <div className="ag-theme-quartz" style={{ height: 400, width: '100%' }}>
                        {selector.loading || searchLoading.loading ? <Loader /> : <AgGridReact
                            ref={gridRef}
                            rowData={rowData}
                            gridOptions={gridOptions}
                            columnDefs={columnDefs}
                            headerHeight={70} // increase header height
                            onCellValueChanged={onCellValueChanged}
                            stopEditingWhenCellsLoseFocus={true}
                            pagination={pagination}
                            paginationPageSize={paginationPageSize}
                            paginationPageSizeSelector={paginationPageSizeSelector}
                            defaultColDef={{
                                sortable: true,
                                filter: true,
                                resizable: true,
                                flex: 1,
                                minWidth: 120,
                            }}
                        />}
                    </div>
                </div>
            </div>
            <AddRestrictRuleMoodal
                open={openAddModal}
                onClose={() => {
                    setOpenAddModal(false);
                    setEditRow(null);
                }}
                onSubmit={editRow ? handleEditSave : handleAddRule}
                editData={editRow}   // 👈 ADD THIS
                plantOptions={plantOptions}
                parentVendorOptions={parentVendorOptions}
                childVendorOptions={childVendorOptions}
                materialOptions={materialOptions}
                scodeOptions={scodeOptions}
                categoryOptions={categoryOptions}
                allData={allData}   // 👈 ADD THIS
            />
            <Dialog open={showDelete}>
                <DialogTitle>
                    Are you sure you want to delete?
                </DialogTitle>

                <DialogActions>
                    <Button onClick={() => setShowDelete(false)}>
                        Cancel
                    </Button>

                    <Button
                        color="error"
                        onClick={confirmDelete}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default ForecastPublishExclusion;